<template>
  <div>
  </div>
</template>

<script>
import Store from '@/client/store'

export default {
  name: 'StoreUpdateView',

  props: {},

  data () {
    return {
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
    async saveStore () {
      if (!this.$route.query) { return }
      const query = Object.assign({ provider: 'shopify', id: 1 }, { ...this.$route.query })

      const store = new Store(query)
      if (!store.hmac) { return }

      try {
        await store.save()
        this.goTo('stores')
      } catch (err) {
        // console.log('Store Err', err)
      }
    }
  },

  watch: {
  },

  async mounted () {
    this.saveStore()
  }
}
</script>
